// extracted by mini-css-extract-plugin
export default {"snippet":"Snippet_snippet__HLPrD","highlight":"Snippet_highlight__29RS5"};